<script setup lang="ts">
defineEmits<{
  onMinus: [];
  onPlus: [];
}>();

withDefaults(
  defineProps<{
    quantity: number;
    disabledMinus?: boolean;
    disabledPlus?: boolean;
    compact?: boolean;
  }>(),
  {
    disabledMinus: false,
    disabledPlus: false,
    compact: false,
  }
);
</script>

<template>
  <div class="flex w-[4.5rem] shrink-0 items-center justify-center gap-0">
    <Button
      outlined
      plain
      icon="pi pi-minus"
      size="small"
      :class="['af-button-thin border-none text-sm text-gray-500', { 'h-7 w-10': compact }]"
      :disabled="disabledMinus"
      @click="$emit('onMinus')"
    />

    <span class="min-w-[2.5rem] text-center text-sm font-semibold tabular-nums text-gray-600">
      {{ quantity }}
    </span>

    <Button
      outlined
      plain
      icon="pi pi-plus"
      size="small"
      :class="['af-button-thin border-none text-sm text-gray-500', { 'h-7 w-10': compact }]"
      :disabled="disabledPlus"
      @click="$emit('onPlus')"
    />
  </div>
</template>
